import { Injectable } from '@angular/core';
import { Subject } from "rxjs";
@Injectable({
  providedIn: 'root'
})
export class LoadingService {
  private _loading: boolean = false;
  loadingStatus: Subject<any> = new Subject();

  get loading():boolean {
    return this._loading;
  }

  set Mloading(value) {
    this._loading = value;
    this.loadingStatus.next(value);
  }

  startLoading() {

    this.Mloading = true;
  }

  stopLoading() {
    setTimeout(() => {
      this.Mloading = false;  
    });
  }
}
